import React from 'react'
import PropTypes from 'prop-types'
import { monsterAttributeIcons } from '../../images'
import { StyledCardTypeImage } from './CardTypeIcon'

const MonsterAttributeIcon = ({ id }) => <StyledCardTypeImage>{monsterAttributeIcons[id] && <img src={monsterAttributeIcons[id]} alt="" />}</StyledCardTypeImage>

MonsterAttributeIcon.propTypes = {
	id: PropTypes.number.isRequired
}

export default MonsterAttributeIcon
